// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js!./vuetify.min.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("3933fb2e", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/dist/vuetify.min.css
// module id = 461
// module chunks = 0